import React from 'react';
import { motion } from 'framer-motion';
import { FaPython, FaJs, FaGitAlt, FaNodeJs, FaCode } from 'react-icons/fa';
import Tilt from 'react-parallax-tilt';
import './Skills.css';

const Skills = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <motion.section
      id="skills"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      // Note: sectionVariants are defined in App.js and passed implicitly through context
    >
      <h2>Skills</h2>
      <div className="skills-category">
        <h3>Languages</h3>
        <ul>
          <motion.li className="skill-list-item" variants={itemVariants}> {/* motion.li for stagger */}
            <Tilt className="skill-item" tiltMaxAngleX={10} tiltMaxAngleY={10} perspective={1000} transitionEasing="cubic-bezier(.03,.98,.52,.99)" scale={1.02} glareEnable={true} glareMaxOpacity={0.45} glareColor="#ffffff" glarePosition="all" >
              <div className="skill-header">
                <motion.div whileHover={{ scale: 1.2, y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                  <FaCode />
                </motion.div>
                <span>Roblox Luau</span>
              </div>
              <div className="skill-details">
                <p className="skill-description">Capable of designing modular and scalable game systems using OOP. Implementing secure client-server communication. Creating dynamic UI systems. Experienced in both frontend and backend aspects.</p>
                <p className="skill-tools">Tools: Roblox Studio, OOP</p>
              </div>
            </Tilt>
          </motion.li>
          <motion.li className="skill-list-item" variants={itemVariants}>
            <Tilt className="skill-item" tiltMaxAngleX={10} tiltMaxAngleY={10} perspective={1000} transitionEasing="cubic-bezier(.03,.98,.52,.99)" scale={1.02} glareEnable={true} glareMaxOpacity={0.45} glareColor="#ffffff" glarePosition="all" >
              <div className="skill-header">
                <motion.div whileHover={{ scale: 1.2, y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                  <FaPython />
                </motion.div>
                <span>Python</span>
              </div>
              <div className="skill-details">
                <p className="skill-description">Capable of basic API integration with various systems.</p>
              </div>
            </Tilt>
          </motion.li>
          <motion.li className="skill-list-item" variants={itemVariants}>
            <Tilt className="skill-item" tiltMaxAngleX={10} tiltMaxAngleY={10} perspective={1000} transitionEasing="cubic-bezier(.03,.98,.52,.99)" scale={1.02} glareEnable={true} glareMaxOpacity={0.45} glareColor="#ffffff" glarePosition="all" >
              <div className="skill-header">
                <motion.div whileHover={{ scale: 1.2, y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                  <FaJs />
                </motion.div>
                <span>JavaScript</span>
              </div>
              <div className="skill-details">
                <p className="skill-description">Primarily used for web development, ensuring web servers function effectively and interact with clients.</p>
              </div>
            </Tilt>
          </motion.li>
          <motion.li className="skill-list-item" variants={itemVariants}>
            <Tilt className="skill-item" tiltMaxAngleX={10} tiltMaxAngleY={10} perspective={1000} transitionEasing="cubic-bezier(.03,.98,.52,.99)" scale={1.02} glareEnable={true} glareMaxOpacity={0.45} glareColor="#ffffff" glarePosition="all" >
              <div className="skill-header">
                <motion.div whileHover={{ scale: 1.2, y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                  <FaCode />
                </motion.div>
                <span>C#</span>
              </div>
              <div className="skill-details">
                <p className="skill-description">Proficient in building games using frameworks like MonoGame.</p>
                <p className="skill-tools">Frameworks: MonoGame</p>
              </div>
            </Tilt>
          </motion.li>
        </ul>
      </div>
      <div className="skills-category">
        <h3>Workflows & Tools</h3>
        <ul>
          <motion.li className="skill-list-item" variants={itemVariants}>
            <Tilt className="skill-item" tiltMaxAngleX={10} tiltMaxAngleY={10} perspective={1000} transitionEasing="cubic-bezier(.03,.98,.52,.99)" scale={1.02} glareEnable={true} glareMaxOpacity={0.45} glareColor="#ffffff" glarePosition="all" >
              <div className="skill-header">
                <motion.div whileHover={{ scale: 1.2, y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                  <FaNodeJs />
                </motion.div>
                <span>Node.js</span>
              </div>
              <div className="skill-details">
                <p className="skill-description">Utilized for web servers, API development, and creating simple real-time dashboards.</p>
              </div>
            </Tilt>
          </motion.li>
          <motion.li className="skill-list-item" variants={itemVariants}>
            <Tilt className="skill-item" tiltMaxAngleX={10} tiltMaxAngleY={10} perspective={1000} transitionEasing="cubic-bezier(.03,.98,.52,.99)" scale={1.02} glareEnable={true} glareMaxOpacity={0.45} glareColor="#ffffff" glarePosition="all" >
              <div className="skill-header">
                <motion.div whileHover={{ scale: 1.2, y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                  <FaGitAlt />
                </motion.div>
                <span>Git</span>
              </div>
              <div className="skill-details">
                <p className="skill-description">Experienced in version control, collaborative development, and managing code repositories.</p>
                <p className="skill-tools">Tools: GitHub, GitLab, Bitbucket</p>
              </div>
            </Tilt>
          </motion.li>
        </ul>
      </div>
    </motion.section>
  );
};

export default Skills;
